export default "__VITE_ASSET__JfBPVrBm__"